module.exports = __webpack_public_path__ + "img/spread.bd3e9e42.svg";